import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import { MARKET_REGION_STATE_FRAGMENT } from '@app/model/market_area/service/MarketAreaStateGraphQLFragments';

export const FIND_MARKET_INSIGHT_QUERY: GraphQL = {
	name: 'findMarketInsight',
	gql: gql`
      ${MARKET_REGION_STATE_FRAGMENT}
      query findMarketInsight($companyHotelId: Long!, $skipDays: Int!) {
          findMarketInsight(companyHotelId: $companyHotelId, skipDays: $skipDays) {
              totalMarketRegionStates
              marketRegionName
              marketAreas {
                  id
                  name
                  own
              }
              marketRegionStates {
                  ...MarketRegionStateFragment
              }
          }
      }`
}

export const FIND_PRICE_INDEX_QUERY: GraphQL = {
	name: 'findPriceIndex',
	gql: gql`
      query findPriceIndex($companyHotelId: Long!, $statDate: LocalDate!, $marketAreaId: Long) {
          findPriceIndex(companyHotelId: $companyHotelId, statDate: $statDate, marketAreaId: $marketAreaId) {
              state
              marketPriceMedianDifference
              myPropertyPriceMedianDifference
              periodInDays
          }
      }`
}

export const FIND_SOLD_OUT_INDICES_QUERY: GraphQL = {
	name: 'findSoldOutIndices',
	gql: gql`
      query findSoldOutIndices($companyHotelId: Long!, $statDate: LocalDate!, $marketAreaId: Long) {
          findSoldOutIndices(companyHotelId: $companyHotelId, statDate: $statDate, marketAreaId: $marketAreaId) {
             indices {
								 rating
								 rate
             }
          }
      }`
}

export const FIND_LOS_INDICES_QUERY: GraphQL = {
	name: 'findLosIndices',
	gql: gql`
      query findLosIndices($companyHotelId: Long!, $statDate: LocalDate!, $marketAreaId: Long) {
          findLosIndices(companyHotelId: $companyHotelId, statDate: $statDate, marketAreaId: $marketAreaId) {
             indices {
								 los
								 rate
             }
          }
      }`
}

export const FIND_OCCUPANCY_INDICES_QUERY: GraphQL = {
	name: 'findOccupancyIndices',
	gql: gql`
      query findOccupancyIndices($companyHotelId: Long!, $statDate: LocalDate!, $marketAreaId: Long) {
          findOccupancyIndices(companyHotelId: $companyHotelId, statDate: $statDate, marketAreaId: $marketAreaId) {
              marketOccupancyRate
              myPropertyOccupancyRate
              ratingIndices {
                  rating
                  marketRate
                  myPropertyRate
              }
							roomTypeIndices {
								roomType
								marketRate
								myPropertyRate
							}
							occupancyDrillDownType
          }
      }`
}

export const FIND_FLIGHT_STATS_QUERY: GraphQL = {
	name: 'findFlightStats',
	gql: gql`
      query findFlightStats($companyHotelId: Long!, $statDate: LocalDate!, $beforeDays: Int!) {
          findFlightStats(companyHotelId: $companyHotelId, statDate: $statDate, beforeDays: $beforeDays) {
							origin
							currentValue
							previousValue
          }
      }`
}

export const FIND_OCCUPANCY_HEXAGONS_QUERY: GraphQL = {
	name: 'findOccupancyHexagons',
	gql: gql`
      query findOccupancyHexagons($companyHotelId: Long!, $statDate: LocalDate!, $marketAreaId: Long) {
          findOccupancyHexagons(companyHotelId: $companyHotelId, statDate: $statDate, marketAreaId: $marketAreaId) {
              center {
                  lat
                  lng
              }
              boundingBox {
                  minLatitude
                  maxLatitude
                  minLongitude
                  maxLongitude
              }

              hexagons {
                  id
                  centerLat
                  centerLng
                  vertices {
                      lat
                      lng
                  }
                  cluster
                  hotelCount
              }
          }
      }`
}
export const FIND_MARKET_BOOKING_CURVE_QUERY: GraphQL = {
    name: 'findMarketBookingCurve',
    gql: gql`
        query findMarketBookingCurve($companyHotelId: Long!, $statDate: LocalDate!, $nights: Int!, $stars: Int!, $marketAreaId: Long) {
            findMarketBookingCurve(companyHotelId: $companyHotelId, statDate: $statDate, nights: $nights, stars: $stars, marketAreaId: $marketAreaId) {
                nights selectedNights stars selectedStars rateState currency newestSnapshotDay
                points { snapshotDay availabilityRate marketRate }
            }
        }`,
};

// The pace strip of Market Pulse: the hotel against its market, per stay date, from one pace run.
export const FIND_MARKET_PACE_QUERY: GraphQL = {
    name: 'findMarketPace',
    gql: gql`
        query findMarketPace($companyHotelId: Long!, $fromDate: LocalDate!, $toDate: LocalDate!) {
            findMarketPace(companyHotelId: $companyHotelId, fromDate: $fromDate, toDate: $toDate) {
                ownSource
                run { startDay endDay isLatest }
                days {
                    statDate verdict reason ownStep marketStep leadInterval
                    evidence { ownLevel marketMeanLevel gapLevels ownRoomChange qualifiedHotels sampleHotels }
                }
            }
        }`,
};
